import store from "@/store";

const getClientObject = function (service, clientId) {
  return store.state.base.user.serviceClients[service].find(client => parseInt(client.id) === parseInt(clientId))
}

export default getClientObject
